interface AIAnswerItem {
  question: string;
  answer: string;
}

interface SharedAIAnswerBlockProps {
  label?: string;
  items: AIAnswerItem[];
}

export default function SharedAIAnswerBlock({ label = 'AI Answer Block — Featured Snippet Ready', items }: SharedAIAnswerBlockProps) {
  return (
    <section className="py-20 bg-[#060e1e]">
      <div className="max-w-5xl mx-auto px-6">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-9 h-9 flex items-center justify-center bg-accent/20 rounded-lg shrink-0">
            <i className="ri-sparkling-line text-accent text-lg"></i>
          </div>
          <span className="text-accent font-body text-xs font-semibold uppercase tracking-widest">{label}</span>
        </div>
        <div className="grid md:grid-cols-2 gap-6">
          {items.map((item, i) => (
            <div
              key={i}
              className="bg-navy/80 border border-white/5 rounded-2xl p-7 hover:border-accent/20 transition-colors"
            >
              <div className="flex items-start gap-3 mb-3">
                <span className="w-6 h-6 flex items-center justify-center bg-accent/20 rounded-full shrink-0 mt-0.5">
                  <i className="ri-question-line text-accent text-xs"></i>
                </span>
                <h3 className="font-heading font-bold text-white text-base leading-snug">{item.question}</h3>
              </div>
              <p className="text-white/55 font-body text-sm leading-relaxed pl-9">{item.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
